import { IconName, InputGroup, Intent, MaybeElement } from '@blueprintjs/core';
import * as React from 'react';

export interface StringInputProps {
  disabled?: boolean;
  inputClassName?: string;
  inputTestId?: string;
  intent?: Intent;
  leftIcon?: IconName | MaybeElement;
  onSetValue: (value: string) => void;
  placeholder?: string;
  rightElement?: JSX.Element;
  testId?: string;
  type?: React.HTMLInputTypeAttribute;
  value: string | null;
}

export const StringInput: React.VFC<StringInputProps> = ({
  disabled,
  inputClassName,
  inputTestId,
  intent,
  leftIcon,
  onSetValue,
  placeholder,
  rightElement,
  testId,
  type,
  value,
}) => (
  <div className="sd-input-string" data-testid={testId}>
    <InputGroup
      className={inputClassName}
      data-testid={inputTestId}
      disabled={disabled}
      intent={intent}
      leftIcon={leftIcon}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        onSetValue(e.target.value);
      }}
      placeholder={placeholder}
      rightElement={rightElement}
      type={type || 'text'}
      value={value || ''}
    />
  </div>
);
